<template>
	<li class="vcx-news-article-card">
		<article class="vcx-p-200 vcx-flex vcx-flex-col">
			<div class="vcx-flex vcx-flex-col vcx-gap-100 vcx-flex-1">
				<h4 class="vcx-subheading-bold vcx-text-inverse">{{ article.title }}</h4>
				<p v-if="article.abstract" class="vcx-body-md vcx-text-gray-30">
					{{ article.abstract }}
				</p>
			</div>
			<div class="vcx-flex vcx-justify-between vcx-items-start vcx-pt-300">
				<ArticleDate
					:date-string="article.date"
					:format="CustomSpacetimeFormat.MONTH_DATE_YEAR"
					classes="vcx-body-md vcx-text-gray-30"
				/>
				<BaseLink
					:link="{
						router: 'vcx-blog-post',
						params: { blogPostUrlSlug: article.slug.current }
					}"
					classes="vcx-body-md-bold vcx-text-decoration-underline vcx-text-inverse"
				>
					Read more <span class="show-for-sr"> about {{ article.title }}</span>
				</BaseLink>
			</div>
		</article>
	</li>
</template>

<script setup lang="ts">
import ArticleDate from '@components/blog/article-date.vue';
import { VcxArticleTeaser } from 'types/sanity/vcx-landing-page';
import { CustomSpacetimeFormat } from 'types/spacetime-formats';

interface Props {
	article: VcxArticleTeaser;
}

defineProps<Props>();
</script>

<style scoped lang="scss">
@use '../../styles/vcx/responsive' as *;

.vcx-news-article-card {
	position: relative;
	width: 400px;
	flex-shrink: 0;
	white-space: normal;
	border-radius: var(--vcx-radius-50);
	overflow: hidden;

	@include vcx-media-smo {
		width: 320px;
	}

	&:nth-child(3n + 1) {
		background-color: rgba(36, 61, 72, 0.7);
	}

	&:nth-child(3n + 2) {
		background-color: rgba(54, 85, 98, 0.7);
	}

	&:nth-child(3n + 3) {
		background-color: rgba(68, 99, 112, 0.7);
	}

	> article {
		height: 100%;

		h4,
		p {
			margin: 0;
		}

		:deep(a) {
			text-decoration-skip-ink: none;
			white-space: nowrap;

			&:hover {
				color: var(--vcx-content-inverse-secondary);
			}
		}
	}
}
</style>
